import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import App from "./App";

import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
